import { Container, Grid, styled } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

export const Wrapper = styled(Container)`
  margin: ${props => props.margin};
`

export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.blue[50]}
  }
`
export const Info = styled(InfoIcon)`
  position: relative;
  top: 2px;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  color: ${props => props.theme.palette.brand.black1};

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`
